import { render } from "./AboutJourneyComp.vue?vue&type=template&id=725a168e&scoped=true"
import script from "./AboutJourneyComp.vue?vue&type=script&lang=js"
export * from "./AboutJourneyComp.vue?vue&type=script&lang=js"

import "./AboutJourneyComp.vue?vue&type=style&index=0&id=725a168e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725a168e"]])

export default __exports__